module.exports = __webpack_public_path__ + "img/11.5c538122.jpg";